import React from 'react'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props {
  text: string
  onClick?: () => void
  IconLeft?: (p: SvgIconProps) => JSX.Element
  IconRight?: (p: SvgIconProps) => JSX.Element
  iconLeftColor?: string
  matches?: boolean
}

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    // marginRight: theme.spacing(1),
  },
  iconLeft: {
    marginRight: theme.spacing(1),
    color: '#555',
  },
  iconRight: {
    marginLeft: theme.spacing(1),
    color: '#555',
  },
}))

export default function ButtonToolbar({
  IconLeft,
  IconRight,
  iconLeftColor,
  text,
  onClick,
  matches = true,
}: Props) {
  const classes = useStyles()
  return (
    <Button
      variant="outlined"
      className={classes.button}
      style={{
        width: matches ? 180 : '100%',
        marginBottom: matches ? 0 : 6,
        marginRight: matches ? 12 : 0,
      }}
      onClick={onClick}
    >
      {IconLeft && (
        <IconLeft
          className={classes.iconLeft}
          style={iconLeftColor ? { color: iconLeftColor } : undefined}
        />
      )}
      {text}
      {IconRight && <IconRight className={classes.iconRight} />}
    </Button>
  )
}
